import React from 'react';
import { CommonHelpers } from '../../helpers';
export var ServersList = function (_a) {
    var servers = _a.servers, config = _a.config, relativePathname = _a.relativePathname;
    if (!servers || servers.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: "mt-2 text-sm" },
        React.createElement("p", null, "Available only on servers:"),
        React.createElement("ul", { className: "flex flex-wrap leading-normal" }, servers.map(function (server) { return (React.createElement("li", { className: "inline-block mt-2 mr-2", key: server.id() },
            React.createElement("a", { href: "".concat(relativePathname, "#").concat(CommonHelpers.getIdentifier('server-' + server.id(), config)), className: "border border-solid border-blue-300 hover:bg-blue-300 hover:text-blue-600 text-blue-500 font-bold no-underline text-xs rounded px-3 py-1 cursor-pointer" },
                React.createElement("span", { className: "underline" }, server.id())))); }))));
};
//# sourceMappingURL=ServersList.js.map